module.exports = __webpack_public_path__ + "47da73e52c097234e8cc607631ddc910.ttf";